

class ErrorSupport {

    private root: HTMLDivElement;
    private errors: string[] = [];
    private infos: string[] = [];

    constructor(root: HTMLDivElement) {
        this.root = root;
    }

    addError(str: string) {
        this.errors.push(str);
    }

    clearErrors() {
        this.errors = [];
    }

    addInfo(str: string) {
        this.infos.push(str);
    }

    clearInfos() {
        this.infos = [];
    }

    getErrors(): string[] {
        // remove duplicates from errors
        this.errors = this.errors.filter((item, index) => this.errors.indexOf(item) === index);
        return this.errors;
    }

    getInfos(): string[] {
        // remove duplicates from infos
        this.infos = this.infos.filter((item, index) => this.infos.indexOf(item) === index);
        return this.infos;
    }

    clearAll(): void {
        this.clearErrors();
        this.clearInfos();
    }

}


export default ErrorSupport;